export default {
    openBannerWithInfo(state, data){
       state.bannerText = data.message;
       localStorage.setItem('bannerState', 'opened');
    }
}
